import comPreview from './Preview'

export default {

	props: ['type', 'item'],

    components: {
        'com-preview': comPreview
    },

    data: function() {
    
        return {
            is: {
                previewing: false
            },
            preview: {
                icon: {
                    'user': 'cell.user',
                    'admin': 'cell.admin',
                    'convention/badge': 'cell.badge',
                    'convention/registration/application': 'cell.application'
                },
                route: {
                    'user': false,
                    'admin': false,
                    'organisation': 'Organisations.Edit',
                    'membership/subscription': 'Membership.Members.Subscriptions.Edit',
                    'convention/badge': 'Convention.Badges.Holders.Edit',
                    'convention/badge/type': 'Convention.Badges.Types.Edit',
                    'convention/volunteers/role': 'Convention.Volunteers.Roles.Edit',
                    'convention/volunteers/slot': 'Convention.Volunteers.Slots.Edit',
                    'convention/volunteers/assignment': 'Convention.Volunteers.Confirmed.Edit',
                    'convention/volunteers/whitelist': 'Convention.Volunteers.Approvals.Edit',
                    'convention/volunteers/signup': 'Convention.Volunteers.Signups',
                    'organisation/library/game': 'Convention.Library.Games.Edit',
                    'convention/registration/application': 'Convention.Registration.Applications.Edit',
                    'convention/registration/sale': 'Convention.Registration.Sales.Edit'
                },
                tooltip: {
                    'user': 'Click to quick view user',
                    'organisation': 'Click to quick view organisation',
                    'membership/subscription': 'Click to quick view membership',
                    'admin': 'Click to quick view admin',
                    'convention/badge': 'Click to quick view badge',
                    'convention/badge/type': 'Click to quick view badge type',
                    'convention/volunteers/role': 'Click to quick view role',
                    'convention/volunteers/slot': 'Click to quick view slot',
                    'convention/volunteers/assignment': 'Click to quick view assignment',
                    'convention/volunteers/whitelist': 'Click to quick view pre-approval',
                    'convention/volunteers/signup': 'Click to quick view sign-up',
                    'organisation/library/game': 'Click to quick view game',
                    'convention/registration/application': 'Click to quick view application',
                    'convention/registration/sale': 'Click to quick view sale'
                },
                reference: {
                    'user': false,
                    'admin': false,
                    'membership/subscription': true,
                    'organisation': true,
                    'convention/badge': true,
                    'convention/badge/type': true,
                    'convention/volunteers/assignment': true,
                    'convention/volunteers/whitelist': true,
                    'convention/volunteers/signup': true,
                    'convention/volunteers/role': false,
                    'convention/volunteers/slot': false,
                    'convention/registration/application': true,
                    'convention/registration/sale': true,
                    'organisation/library/game': true
                }
            }
        }

    },

    methods: {
    
        onPreviewClick: function() {

            if (this.item) this.is.previewing = true
        
        },

        onPreviewFollow: function(item) {

            if (item) this.$router.push({
                name: this.preview.route[this.type],
                params: {
                    id: item.id,
                    role: (item.role) ? item.role.id : false
                }
            })
        
        }
    
    }

}